/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

/**
 * Reusable React component - Footer.
 *
 * @namespace Loader
 */
class Loader extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { loaderClassName } = this.props;
    return (
      <div className={loaderClassName || "loader-wrapper"}>
        <div className="loader-icon icon"></div>
      </div>
    );
  }
}

export default Loader;
